import type { LicenseState } from './license.types';

export const LICENSE_INITIAL_STATE: LicenseState = {
  licenses: {
    data: [],
    loading: 'idle',
    error: { name: '', message: '' },
  },
};

export const LICENSES_FETCHING_ERROR_PREFIX = 'Failed to fetch licenses';
export const PROJECT_LICENSE_ASSIGN_ERROR_PREFIX = 'Failed to assign license to project';
export const PROJECT_LICENSE_REMOVE_ERROR_PREFIX = 'Failed to remove license from project';
